import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {sendAmWelcomeEmailNoGift} from 'src/openapi/admin/apis/UsersEmailsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
};

export const useSendAmNoGiftWelcomeEmail = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(
        (requestBody: number[]) => apiDispatch(sendAmWelcomeEmailNoGift({userId, requestBody})),
        [userId, apiDispatch],
    );

    return useCommonEventHook({eventAction});
};
